import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace WhatsAppUsageValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
